<script>
    export let what     = ''
    export let error    = false
    export let inverted = false
</script>

<div class="ui"> 
    <div class:inverted={!error} class="ui active page dimmer">
        <div class="ui text loader">
            {#if error} Erro carregando dados {:else} {what} {/if}
        </div>
    </div>
</div>
